// Animate only decorative layers; ordinary scrolling and content never depend on JS.
class RahlleSportBackdrop extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.rh-editorial');
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.queue = () => {
      if (!this.visible || this.motion.matches || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        const rect = this.section.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1,
          (window.innerHeight / 2 - rect.top - rect.height / 2) /
          ((window.innerHeight + rect.height) / 2)));
        const travel = window.innerWidth < 750 ? 42 : 90;
        this.style.setProperty('--sport-y', `${progress * travel}px`);
        this.style.setProperty('--sport-angle', `${progress * 16}deg`);
      });
    };
    this.changeMotion = () => {
      if (this.motion.matches) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.style.removeProperty('--sport-y');
        this.style.removeProperty('--sport-angle');
      } else this.queue();
    };
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.queue();
    });
    this.observer.observe(this.section);
    // Horizon scrolls .page-wrapper; capture also supports document scrolling.
    document.addEventListener('scroll', this.queue, { passive: true, capture: true });
    window.addEventListener('resize', this.queue);
    this.motion.addEventListener('change', this.changeMotion);
  }

  disconnectedCallback() {
    this.observer.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    document.removeEventListener('scroll', this.queue, true);
    window.removeEventListener('resize', this.queue);
    this.motion.removeEventListener('change', this.changeMotion);
  }
}

if (!customElements.get('rh-sport-backdrop')) {
  customElements.define('rh-sport-backdrop', RahlleSportBackdrop);
}
